import $ from 'jquery';

export default class ProTips {
  constructor($elem) {
    this.$elem = $elem;

    this.currentSlide = 0;

    this.click__close = this.click__close.bind(this);
    this.click__trigger = this.click__trigger.bind(this);
    this.click__next = this.click__next.bind(this);

    this._init();
  }

  click__close(ev) {
    ev.preventDefault();

    $(ev.currentTarget).blur();

    this.currentSlide = 0;
    this.hide();
  }

  click__next(ev) {
    ev.preventDefault();

    $(ev.currentTarget).blur();

    this.currentSlide ++;
    this.moveTo(this.currentSlide);
  }

  click__trigger(ev) {
    ev.preventDefault();

    this.moveTo(0);
    this.show();
  }

  hide() {
    var $self = this.$elem;
    $self.fadeOut(250, function() { $self.addClass('is-hidden'); });
  }

  moveTo(slide) {
    var $slides     = this.$elem.find('.pro-tip'),
        $slide      = $slides.eq(slide),
        target      = $slide.data('target'),
        position    = $slide.data('position'),
        offset_x    = $slide.data('offset-x'),
        offset_y    = $slide.data('offset-y'),
        $target     = $(target),
        target_pos  = $target.offset(),
        $pips       = this.$elem.find('.pip'),
        $pip        = $pips.eq(slide),
        x, y;

    x = target_pos.left;
    y = target_pos.top;

    switch(position) {
      case 'above':
        y = y - offset_y;
        break;
    }

    $slides.removeClass('is-active');
    $slide.addClass('is-active');
    $pips.removeClass('is-active');
    $pip.addClass('is-active');

    if ((this.currentSlide + 1) == $slides.length) {
      this.$elem.find('.pro-tips__next').addClass('is-hidden');
      this.$elem.find('.pro-tips__close').removeClass('is-hidden');
    } else {
      this.$elem.find('.pro-tips__next').removeClass('is-hidden');
      this.$elem.find('.pro-tips__close').addClass('is-hidden');
    }

    this.$elem.css({ left : x, top : y });
  }

  show() {
    var $self = this.$elem;
    $self.fadeIn(250, function() { $self.removeClass('is-hidden'); });
  }

  _init() {
    $('body')
      .on('click', '.pro-tips__trigger', this.click__trigger);

    this.$elem
      .on('click', '.close, .pro-tips__close', this.click__close)
      .on('click', '.pro-tips__next', this.click__next);
  }
}
